import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate'

const configVee = {
    fieldsBagName: 'fieldsVee'
}
Vue.use(VeeValidate, configVee)
